var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVpinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#98A2B3",
    d: "M10 0C4.477 0 0 4.477 0 10c0 4.238 2.637 7.855 6.355 9.313-.085-.793-.168-2.004.036-2.868l1.171-4.968s-.3-.598-.3-1.485c0-1.39.804-2.43 1.808-2.43.852 0 1.266.641 1.266 1.41 0 .86-.547 2.141-.828 3.329-.235.996.5 1.808 1.48 1.808 1.778 0 3.145-1.875 3.145-4.578 0-2.394-1.719-4.07-4.176-4.07-2.844 0-4.516 2.133-4.516 4.34 0 .86.332 1.781.747 2.281a.299.299 0 0 1 .07.285c-.074.317-.246.996-.278 1.133-.043.184-.144.223-.335.133-1.25-.582-2.032-2.406-2.032-3.875 0-3.156 2.293-6.051 6.606-6.051 3.469 0 6.164 2.473 6.164 5.777 0 3.446-2.172 6.22-5.188 6.22-1.011 0-1.965-.528-2.293-1.15 0 0-.5 1.91-.62 2.38-.227.867-.837 1.957-1.243 2.62.938.29 1.93.446 2.961.446 5.523 0 10-4.477 10-10S15.523 0 10 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpinterest);
export default __webpack_public_path__ + "static/media/vpinterest.08119902097d2f8a287d8fb3960a3023.svg";
export { ForwardRef as ReactComponent };